@if (dtypeForm) {
    <div class="flex flex-col md:flex-row w-full">
        <dtype-component-list class="w-full" [dtypeForm]="dtypeForm"></dtype-component-list>
    </div>
}